var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { useMemo } from "react";
var counter = function () {
  var counts = {};
  return function (name) {
    counts[name] = ++counts[name] || 1;
    return counts[name];
  };
}();
var SvgFavoritesOutlined = function SvgFavoritesOutlined(props) {
  var key = useMemo(function () {
    return counter(SvgFavoritesOutlined);
  }, []);
  var getId = function getId(baseId) {
    return "".concat(baseId, "__").concat(key);
  };
  var getRef = function getRef(baseId) {
    return "#".concat(getId(baseId));
  };
  var getUrl = function getUrl(baseId) {
    return "url(".concat(getRef(baseId), ")");
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": props.title ? "SvgFavoritesOutlined__title" : undefined
  }, props), props.title && /*#__PURE__*/React.createElement("title", {
    id: "SvgFavoritesOutlined__title",
    lang: "en"
  }, props.title), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_66_19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.247 3.19699C18.059 -0.941007 11.786 1.49699 11.786 5.70299C11.786 1.50299 5.51199 -0.942007 2.32399 3.19699C-0.970014 7.47499 2.27599 14.97 11.786 19.276C21.295 14.97 24.542 7.47499 21.247 3.19699Z",
    stroke: "currentColor",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66_19"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.572,
    height: 20.374,
    fill: "white"
  })))));
};
export default SvgFavoritesOutlined;